export const unlockInfluencersOptions = [
    { label: '25', value: 25 },
    { label: '50', value: 50 },
    { label: '75', value: 75 },
    { label: '100', value: 100 },
    // { label: '125', value: 125 },
    // { label: '150', value: 150 },
    { label: 'Custom', value: 'custom' },
  ];